var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    d: "M24.875 12c0-6.624-5.376-12-12-12s-12 5.376-12 12c0 5.808 4.128 10.644 9.6 11.76V15.6h-2.4V12h2.4V9c0-2.316 1.884-4.2 4.2-4.2h3v3.6h-2.4c-.66 0-1.2.54-1.2 1.2V12h3.6v3.6h-3.6v8.34c6.06-.6 10.8-5.712 10.8-11.94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.875 0h24v24h-24z"
  })))));
};
export default SvgFacebook;